import React from "react";
import themePropTypes from "../theme-prop-types";
import CaseTable from "./case-table";

const getCaseListItem = ({ cases, components, onView, settings }) => [
  {
    type: "raw",
    el: (
      <CaseTable
        cases={cases}
        components={components}
        onView={onView}
        settings={settings}
      />
    )
  }
];

getCaseListItem.propTypes = themePropTypes.caseListItem;

export default getCaseListItem;
